import React from 'react';
import { shadows } from '../../theme';
import { OptionStyled, SelectIcon, SelectStyled } from './Select.styles';
const Select = ({ children, ...props }) => {
    return (React.createElement(SelectStyled, { select: true, SelectProps: {
            native: true,
            IconComponent: (props) => (React.createElement(SelectIcon, { name: "chevron-down", ...props })),
            MenuProps: {
                PaperProps: {
                    elevation: 0,
                    style: {
                        boxShadow: shadows.l,
                    },
                },
            },
        }, ...props }, children));
};
export const Option = ({ ...props }) => {
    return (React.createElement(OptionStyled, { ...props }));
};
export default Select;
//# sourceMappingURL=Select.js.map